<script>
import { mapState } from 'vuex'

export default {
  name: 'Home',
  computed: {
    ...mapState({
      usuario: state => state.moduleLogin.usuario,
      user: state => state.moduleLogin.user
    })
  }
}
</script>

<template>
  <b-container class="container" style="background-color:#6c7a89;">
    <p class="bemvindo">Bem Vindo {{usuario.nomUsuario}}, sua Pesquisa LPR da Cidade: {{user.cidade}}</p>
      <router-link to="/home">
        <div class="geral_div">
          <font-awesome-icon :icon="['fas', 'home']" size="8x" class="icones_home" /> 
          <p class="legenda">Inicio</p>
        </div>
      </router-link>
      
      <router-link to="/PesquisaPlacas">
        <div class="geral_div">
          <font-awesome-icon :icon="['fas', 'photo-video']" size="8x" class="icones_home"/>
          <p class="legenda">Pesquisa Placas</p>
        </div>
      </router-link>
      
      <router-link to="/CadastroTelegram">
        <div class="geral_div">
          <font-awesome-icon :icon="['fab', 'telegram-plane']" size="8x" class="icones_home"/>
          <p class="legenda">Telegram</p>
        </div>
      </router-link>

      <router-link to="/CadastroAlerta">
        <div class="geral_div">
          <font-awesome-icon :icon="['fas', 'book']" size="8x" class="icones_home"/>
          <p class="legenda">Cadastrar Alerta</p>
        </div>
      </router-link>

      <router-link v-if="user.cidade == 'Itaipu'" to="/CadastroEmail" >
        <div class="geral_div">
          <font-awesome-icon :icon="['fas', 'envelope']" size="8x" class="icones_home"/>
          <p class="legenda">Cadastrar Email</p>
        </div>
      </router-link>
  </b-container>
</template>

<style scoped>
.geral_div{
  display: inline-block;
}

.legenda{
  color: #f8f8ff;
  font-weight: bold;
}

.icones_home{
  border-color: #f8f8ff;
  border-style: solid;
  border-radius: 16px;
  margin: 10px;
  padding: 15px;
  color: #b3b3b3
}

.bemvindo {
  color: #f8f8ff !important;
  font-weight: bold;
}
</style>